import { getFactura } from "features/Documentos/redux/documentosExtraActions"
import {
  documentosSelector,
  showVerDocumentoModal,
} from "features/Documentos/redux/documentosSlice"
import { useDispatch } from "hooks/useDispatch"
import { useSelector } from "hooks/useSelector"
import { useEffect } from "react"

const useGetFactura = () => {
  const dispatch = useDispatch()
  const { selectedDocumento, factura, isVerDocumentoModalShowing } =
    useSelector(documentosSelector)

  useEffect(() => {
    if (factura?.id) {
      dispatch(showVerDocumentoModal(factura))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [factura])

  const handleOpenModalFacturaDetail = (documento: $TSMigrationFixMe) => {
    dispatch(getFactura(documento.facturaId || documento.id))
  }

  return {
    handleOpenModalFacturaDetail,
    selectedDocumento,
    factura,
    isVerDocumentoModalShowing,
  }
}

export default useGetFactura
